<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="就诊记录"></el-page-header>
    <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
    <ul class="basic-info" v-if="contact && contact.name">
        <li><b>姓名：</b>{{contact.name}}</li>
        <li><b>性别：</b>{{contact.sex == '1'?'男':'女'}}</li>
        <li><b>电话：</b>{{contact.phoneNo}}</li>
        <li><b>出生日期：</b>{{contact.birthday}}</li>
        <li><b>常住地址：</b>{{contact.liveArea}}</li>
        <li><b>出生地址：</b>{{contact.birthArea}}</li>
    </ul>
    <div class="sub-container">
      <el-table :data="currentOrderList" @row-click="tableClick" style="width: 1080px;" :border="tableBorder" v-show="currentOrderList.length > 0">
        <el-table-column prop="visitRecordId" align='left' label="订单号" width="280">
        </el-table-column>
        <el-table-column prop="typeText" label="处方类型" align='left' width="160">
        </el-table-column>
        <el-table-column prop="patientPhoneNo" label="病人手机号" align='left' width="160">
        </el-table-column>
        <el-table-column prop="createTimeString" label="下单时间" align='left' width="230">
        </el-table-column>
        <el-table-column prop="price" label="订单价格" align='left' width="120">
        </el-table-column>
        <el-table-column prop="statusDesc" label="订单状态" align='left' width="120">
        </el-table-column>
      </el-table>
      <div class="empty-container" v-if="currentOrderList.length == 0">
        <span>{{emptyText}}</span>
      </div>
      <div style="width: 100%;font-size: 16px; text-align: center;margin-bottom: 30px;margin-top: 20px;color: #666;">{{tipsDate}}</div>
    </div>
  </div>

</template>

<script>
  import AreaHeader from '@/components/widgets/area-header.vue'
  import dateUtils from '../../js/date'
  let un_pay_status  = "0" //未支付
  let payed_status  = "1" //已支付
  let order_avaliable_status  = "2" //订单生效
  let prescripting_status  = "3" //配药中
  let expressing_status  = "4" //配送中
  let express_complete_status  = "5" //配送完成
  import WJTRadio from '@/components/widgets/wjt-radio.vue'
  export default {
    name:'medicalRecords',
    components:{
        WJTRadio,
        AreaHeader
    },
    data() {
      return {
        currentOrderList: [],
        tableBorder: false,
        emptyText: '您还没有就诊记录',
        editable: false,
        confirmLoading: false,
        currentIndex:0,
        patientName:"",
        tipsDate:"",
        contact:{}
      }
    },
    created() {
      this.contact = JSON.parse(sessionStorage.getItem("contactInfo"))
      this.getOrderList()
      this.tipsDate = dateUtils.generateNewDate()
    },
    methods: {
      goBack(){
        this.$router.go(-1)
      },
      getOrderList() {
        this.wjtHttp.get(this, '/api/health/v2/prescription/patient/'+this.contact.patientId, {}, true, (res) => {
          var data = res.data
          if (data.code == 200) {
            this.tipsDate = data.msg;
            var orderList = data.data
            if(this.utils.isEmptyStr(orderList)) {
              this.emptyText = "您当前沒有就诊记录"
            }else{
              for(var i=0;i<orderList.length;i++){
                orderList[i].typeText = orderList[i].type == 'S'?'自拟组方':'智能开方'
              }
            }
            this.currentOrderList = orderList
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '接口异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      },
      tableClick(row,column,event){
        if(row.status == '1'){
          if(row.type == "P"){
            this.$router.push({
              path:'/prescription',
              query:{
                visitRecordId:row.visitRecordId,
                patientId:row.patientId
              }
            })
          }else{
            this.$router.push({
              path:'/handmadePrescriptionDetails',
              query:{
                visitRecordId:row.visitRecordId
              }
            })
          }

        }
      },
    }
  }

</script>

<style scoped>
  .container{
      width: 1080px;
      margin: auto auto;
  }
  .page-header{
      width: 1080px;
      margin-top: 30px;
      color: #333333;
      font-size: 20px;
  }
  .page-header >>> div{
      color:#333333;
      font-size: 20px;
  }
  .basic-info{
      width: 1080px;
      margin-top: 30px;
      margin-bottom: 15px;
  }
  .area-header-one{
    margin-top: 35px;
  }
  .basic-info>li{
      color: #333333;
      font-size: 18px;
      text-align: left;
      line-height: 40px;
  }
  .basic-info>li>b{
      font-weight: bold;
  }
  .sub-container {
    width: 1080px;
    margin: auto auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

  }

  .btn-add-contact {
    height: 40px;
    font-size: 14px;
  }

  .contact-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 30px;
    background: #F9F9F9;
    width: 1120px;
  }
  .input-circle{
      width: 300px;
      height: 32px;
      margin-left: 190px;
      margin-bottom: 8px;
  }
  .button-search{
    height: 42px;
    width: 100px;
    margin-left: 20px;
  }
  .input-circle >>> input{
      border-radius: 30px;
      padding-left: 20px;
      padding-right: 20px;
  }
  .divider {
    width: 1080px;
    background: #EEEEEE;
    height: 1px;
  }

  .pagination {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .empty-container {
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .empty-container>span {
    font-size: 20px;
    color: #AEAEAE;
  }

  .contact-dialog {
    border-radius: 10px;
  }

  .radio-button-one {
    margin-right: 50px;
  }

  .dialog-picker {
    width: 350px;
  }

  .address-picker1 {
    width: 350px;
  }

  .address-picker2 {
    width: 350px;
  }

  .dialog-form {
    width: 450px;
  }

  .dialog-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-dialog-cancel {
    margin-right: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }

  .btn-dialog-confirm {
    margin-left: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }
  .dialog-wrapper{
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .qrcode-dialog-text{
      color: #333333;
      font-size: 20px;
      margin-top: 30px;
  }
  .qrcode-dialog-text>b{
      color:#156098;
      font-size: 20px;
      cursor: pointer;
  }
  .pay-form{
    position: relative;
    left: 174px;
    margin-top: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/medicalRecords.vue